import { useAuth } from 'contexts/auth';
import InstructorSubmissionsPage from 'pages/InstructorSubmissions';
import StudentSubmissionsPage from 'pages/StudentSubmissions';

const SubmissionsPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorSubmissionsPage />;
    if (auth.role === 'ta') return <InstructorSubmissionsPage />;
    if (auth.role === 'student') return <StudentSubmissionsPage />;
    return null;
};

export default SubmissionsPage;
